import { render } from "./FooterComponent.vue?vue&type=template&id=3a9425b7&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=3a9425b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9425b7"]])

export default __exports__